import dayjs from 'dayjs';

import { USAGE_MAX_RANGE_DAYS } from './tutorAiLimits';

/**
 * Se o período do filtro de uso pode ser consultado.
 *
 * As duas datas precisam estar preenchidas e ser válidas, `dateStart` não pode ser
 * posterior a `dateEnd`, e a janela não pode passar de {@link USAGE_MAX_RANGE_DAYS} dias.
 * Sem os dois primeiros gates, limpar o campo "De" manda `start=` vazio e a API responde
 * 400 "Período inválido"; um intervalo invertido tem o mesmo problema. O terceiro é a
 * regra de produto e, de quebra, impede que um ano digitado errado no filtro — o
 * `DatePicker` aceita qualquer ano de 4 dígitos, sem confirmação — chegue aos utils que
 * densificam a série por dia e trave a aba.
 *
 * É a fonte única da regra: os hooks de dashboard e de agregado a compartilham, e os utils
 * de densificação a repetem por serem a fronteira que aloca.
 *
 * @param dateStart - Início do período, ISO `YYYY-MM-DD`
 * @param dateEnd - Fim do período, ISO `YYYY-MM-DD`
 * @returns `true` se o período pode ir para a API e para os utils de série
 *
 * @example
 * ```ts
 * isUsagePeriodValid('2026-07-01', '2026-07-30'); // true
 * isUsagePeriodValid('2026-07-01', '2026-07-31'); // false — 31 dias
 * ```
 */
export function isUsagePeriodValid(dateStart: string, dateEnd: string): boolean {
  if (!dateStart || !dateEnd) return false;

  const start = dayjs(dateStart);
  const end = dayjs(dateEnd);

  if (!start.isValid() || !end.isValid() || start.isAfter(end)) return false;

  // `diff` conta os intervalos entre as datas; o `+ 1` o converte na contagem inclusiva de
  // dias que `USAGE_MAX_RANGE_DAYS` expressa — 01/07 a 30/07 são 30 dias, não 29.
  return end.diff(start, 'day') + 1 <= USAGE_MAX_RANGE_DAYS;
}
